import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const AssetTypeFieldsRevisionSettingsDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId"
					to="/$organizationId/settings/asset-types/$assetTypeId/fields"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Fields
					</Button>
				</Link>
			}
		/>
	)
})
AssetTypeFieldsRevisionSettingsDetailViewTopBar.displayName = "AssetTypeFieldsRevisionSettingsDetailViewTopBar"
